// test1381
(1381 && 0);
